// ChatMap Hills — hill-targets API client. Mirrors workService.ts (the `api`
// axios instance is base-pathed at /api). SP3a ships GET only; SP3b adds
// putHillTarget (PUT) + forkHillTarget (POST .../fork).
import api from './api';
import type { HillTargetOut, HillTargetSet, HillForkRequest, HillForkResult } from '../types/hill';

export const hillTargetsApiClient = {
  getHillTargets: async (sessionId: string): Promise<HillTargetOut[]> => {
    const r = await api.get(`/sessions/${sessionId}/hill-targets`);
    return r.data;
  },
  putHillTarget: async (sessionId: string, payload: HillTargetSet): Promise<HillTargetOut[]> => {
    const r = await api.put(`/sessions/${sessionId}/hill-targets`, payload);
    return r.data;
  },
  forkHillTarget: async (sessionId: string, body: HillForkRequest): Promise<HillForkResult> => {
    const r = await api.post(`/sessions/${sessionId}/hill-targets/fork`, body);
    return r.data;
  },
};
